import { GeoItem, GeoSearchResponse } from "common";

// Prepare GEO Search by splitting user entered text by comma, space, or newline
export const prepareGEOSearch = (search: string): string[] => {
  return search
    .trim()
    .split(/[,\s]+/g)
    .map((item: string) => item.trim())
    .filter(Boolean);
};

export const manipulateGeoSearchResult = (
  data: Record<string, GeoItem | GeoSearchResponse | []>
): GeoItem[] | GeoSearchResponse[] => {
  const { uids } = data;
  const result: unknown = [];

  (uids as []).forEach((id: string) => {
    const item = data[id];
    if (Object.prototype.hasOwnProperty.call(item, "accession")) {
      if ((item as GeoSearchResponse).accession.startsWith("GSM")) {
        (result as GeoSearchResponse[]).push({
          accession: item["accession"],
          title: item["title"],
        });
      }
    }

    if (
      Object.prototype.hasOwnProperty.call(item, "runs") &&
      Object.prototype.hasOwnProperty.call(item, "expxml")
    ) {
      const parser = new DOMParser();
      const runs = item["runs"];
      const expxml = item["expxml"];
      const expxmlDoc = parser.parseFromString(
        `<document>${expxml}</document>`,
        "text/xml"
      );
      const runsDoc = parser.parseFromString(
        `<document>${runs}</document>`,
        "text/xml"
      );
      let name = expxmlDoc.querySelector("Title")?.textContent || "";
      name = name.replace(/[^a-z0-9._-]/gi, "_").replace(/_+/g, "_");
      const runSelector =
        (runsDoc.querySelectorAll("Run") as NodeListOf<Element>) || [];
      const srrIds = Array.from(runSelector).map(
        run => run?.getAttribute("acc") || ""
      );
      const collectionType = expxml.includes("<SINGLE") ? "Single" : "Paired";

      srrIds.forEach(srrId => {
        (result as GeoItem[]).push({
          srrId,
          name,
          collectionType,
        });
      });
    }
  });

  return (result as GeoItem[] | GeoSearchResponse[]).filter(Boolean) as
    | GeoItem[]
    | GeoSearchResponse[];
};

export const decideToFetchEna = (
  data: GeoItem[] | GeoSearchResponse[] | undefined
) => {
  if (!data) {
    return false;
  }
  if ("accession" in data[0]) {
    return false;
  }
  return true;
};
